export const numberOnPaste = (e: any) => {
    const pastedData = e.clipboardData.getData("text");

    const regex = /[0-9]/;

    if (!regex.test(pastedData)) {
        e.preventDefault();
    }
}